import React from 'react'
import { Box, Text, Flex, Card } from 'pcln-design-system'
import { TravelBotAvatar } from '@pcln/uc-chat-bot'
import { LOCATION_SEARCH_TYPE } from '@/types'
import CityLink from './CityLink'

const TextSpan = Text.span

const getCityListComponent = (
  onLocationSelect: (item: LOCATION_SEARCH_TYPE) => void
) => {
  return function CitiesList(props: {
    citiesList: string[]
    postfixStr: string
    prefixString: string
  }) {
    const { citiesList, postfixStr, prefixString } = props

    return (
      <Flex my={3}>
        <TravelBotAvatar />
        <Card borderRadius={16} ml={3} p={2} bg="primary.light">
          {prefixString ? (
            prefixString.split('\n').map((str, index) => {
              return (
                <Text key={`prefixStr-${index.toString()}`} fontSize={2}>
                  {str}
                </Text>
              )
            })
          ) : (
            <Text fontSize={2}>
              Look at the locations below and select one to start your search!
            </Text>
          )}
          {citiesList.map((location, index) => {
            const [city, state, ...rest] = location.split(',')
            return (
              <Box key={`citiesList-${index.toString()}`} my={2}>
                <CityLink
                  city={city}
                  state={state}
                  onLocationSelect={onLocationSelect}
                  index={index}
                />
                <TextSpan fontSize={2}>{rest?.join(', ')}.</TextSpan>
              </Box>
            )
          })}
          {postfixStr.split('\n').map((str, index) => {
            return (
              <Text key={`string-${index.toString()}`} fontSize={2}>
                {str}
              </Text>
            )
          })}
        </Card>
      </Flex>
    )
  }
}

export default getCityListComponent
